import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";

export default makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
      height: "100%",
    },
    info: {
      textAlign: "center",
      margin: "10px 0",
    },
    successMessage: {
      color: "green",
      margin: "24px 0",
    },
    successIcon: {
      color: "green",
      fontSize: 120,
      marginBottom: 24,
    },
    errorIcon: {
      fontSize: 120,
      marginBottom: 24,
    },
    rejectMessage: {
      color: "#0088ff",
      marginBottom: 24,
      fontWeight: "bold",
    },
    returnButton: {
      maxWidth: 300,
      marginTop: 24,
    },
  })
);
